import React from "react";
const StatsCard = ({
  title,
  value,
  icon: Icon,
  iconBgColor = "bg-blue-50",
  iconColor = "text-blue-600",
  valueColor = "text-gray-900",
  subtitle = null,
}) => {
  return (
    <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm transition-all duration-300 sm:rounded-2xl sm:p-5 lg:p-6 hover:shadow-lg hover:-translate-y-1">
      <div className="flex justify-between items-center">
        <div className="flex-1 min-w-0">
          <p className="mb-1 text-xs font-medium text-gray-600 truncate sm:text-sm">
            {title}
          </p>
          <p className={`text-2xl font-bold sm:text-3xl lg:text-4xl ${valueColor}`}>
            {value}
          </p>
          {subtitle && (
            <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
          )}
        </div>
        <div className={`flex-shrink-0 p-3 ml-3 rounded-xl sm:p-3 ${iconBgColor}`}>
          <Icon className={`w-5 h-5 sm:w-6 sm:h-6 lg:w-7 lg:h-7 ${iconColor}`} />
        </div>
      </div>
    </div>
  );
};

export default StatsCard;

